// extracted by mini-css-extract-plugin
module.exports = {"container":"featuredTournamentsItem__container___14tSh","arrow-icon":"featuredTournamentsItem__arrow-icon___3DOaD","name":"featuredTournamentsItem__name___3AR-H"};